function tableRowAsLink(){
    const rows = window.document.querySelectorAll('.js_table-row-link');

    if(rows.length < 1) return;
    rows.forEach(row => {
        row.addEventListener('click',function(){
            const url = row.getAttribute('data-table-row-link');
            window.location.href = url;
        })
    })
}
window.addEventListener('load',tableRowAsLink);